module.exports = __webpack_public_path__ + "img/approve-fill.bed5729a.svg";